import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { ReactNode } from "react";

type APExpandableRowProps = {
  id: string;
  children: ReactNode;
  labelRenderer: (expanded: boolean) => ReactNode;
  expanded: boolean;
  onExpandToggle: () => void;
  numberOfColumns: number;
};

const APExpandableRow = ({
  id,
  children,
  labelRenderer,
  expanded,
  onExpandToggle,
  numberOfColumns,
}: APExpandableRowProps) => {
  return (
    <>
      <TableRow
        key={`${String(id)}-expandable-row`}
        onClick={() => onExpandToggle()}
        sx={{ cursor: "pointer", backgroundColor: "neutralGray.light" }}
      >
        {labelRenderer(expanded)}
        {Array.from({ length: numberOfColumns }).map((_, index) => (
          <TableCell key={`${String(id)}-expandable-row-${index}`} />
        ))}
      </TableRow>
      {expanded && children}
    </>
  );
};

export default APExpandableRow;
